import { render, staticRenderFns } from "./ModeratorCards.vue?vue&type=template&id=54bcf0b3&scoped=true&"
import script from "./ModeratorCards.vue?vue&type=script&lang=js&"
export * from "./ModeratorCards.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorCards.vue?vue&type=style&index=0&id=54bcf0b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bcf0b3",
  null
  
)

export default component.exports